// vendors
import { useMutation } from 'react-query';
import React, { useMemo, useState } from 'react';

// utils
import { useTranslation } from 'react-i18next';

// lego
import { Modal } from 'lego-dist';

// components
import DirectorItem from './DirectorItem';
import Dialog from 'components/dialog/Dialog';
import { TooltipSortArrow } from '../SortArrow';

// styles
import {
  List,
  ListName,
  ListRole,
  ListEmail,
  ListHeader,
  ListAssignedClasses,
} from './styles/DirectorList';

// queries
import { deleteDirectorQuery } from '../queryConfig/centerQuery';
import DeleteClassroomSuccess from 'views/DeleteClassroomView/SuccessView';
import { EmptyList } from '../sharedComponents/styles/EmptyList';

interface DirectorListProps {
  directors?: any;
  selectedAll?: boolean;
  selectedDirectors?: any;
  toggleSelectDirector?(director: any): void;
  handleOnDirectorDeleted?: Function;
}

const DirectorList: React.FC<DirectorListProps> = ({ directors, selectedDirectors, toggleSelectDirector, handleOnDirectorDeleted = () => {} }) => {
  const { t: translate } = useTranslation();
  const [alphaSort, setAlphaSort] = useState(false);
  const [directorIdToDelete, setDirectorIdToDelete] = useState<any>(null);

  const [deleteDirector, { isSuccess: wasDirectorDeleted }] = useMutation(
    deleteDirectorQuery.resource,
  );

  /* DELETE TEACHER functions */
  const onDeleteDirector = () => {
    if(directorIdToDelete) {
      deleteDirector(directorIdToDelete)
    }
  };

  /* SORT teacher list */
  const renderDirectors = (list: any) => {
    return list.map((item: any, index: any) => {
      return (
        <DirectorItem
          selected={selectedDirectors?.find((director: any) => director.id === item.id)}
          key={index}
          toggleSelectDirector={toggleSelectDirector}
          director={item}
          onClickDeleteDropDown={setDirectorIdToDelete}
        />
      );
    });
  };

  useMemo(() => {
    if(wasDirectorDeleted) {
      setDirectorIdToDelete(null);
      if( handleOnDirectorDeleted ) {
        handleOnDirectorDeleted();
      }
    }
    // eslint-disable-next-line
  }, [wasDirectorDeleted]);

  return (
    <List>
      <ListHeader>
        <ListName>
          {translate('settings:DIRECTOR_NAME')}
          <TooltipSortArrow sorted={alphaSort} onSort={setAlphaSort} />
        </ListName>
        <ListAssignedClasses>
          {translate('settings:ASSIGNED_CENTERS')}
        </ListAssignedClasses>
        <ListRole>{translate('common:ROLE')}</ListRole>
        <ListEmail>{translate('common:EMAIL')}</ListEmail>
      </ListHeader>
      {directors.length > 0 ? (
        renderDirectors(alphaSort ? directors.reverse() : directors)
      ) : (
        <EmptyList>
          {translate('settings:CENTER_SECTION.DIRECTORS_EMPTY')}
        </EmptyList>
      )}

      <Dialog
        mainText={translate('common:DELETE')}
        cancelText={translate('common:CANCEL')}
        title={translate(
          'settings:CENTER_SECTION.DIRECTOR_DELETE.MODAL_CONFIRM.TITLE',
        )}
        show={directorIdToDelete}
        onMainAction={onDeleteDirector}
        onDialogClose={() => setDirectorIdToDelete(null)}
        onCancelAction={() => setDirectorIdToDelete(null)}
      >
        <>
          {translate(
            'settings:CENTER_SECTION.DIRECTOR_DELETE.MODAL_CONFIRM.TEXT',
          )}
        </>
      </Dialog>
      <Modal
        showCloseButton
        closeButtonColor="#ACC2D3"
        openModal={wasDirectorDeleted}
      >
        {() => <DeleteClassroomSuccess header="Director deleted" />}
      </Modal>
    </List>
  );
};

export default DirectorList;
